// extracted by mini-css-extract-plugin
export default {"control":"Product_control__b+dWb","richText":"Product_richText__4nCSU"};